module.exports = __webpack_public_path__ + "img/20190719164005838.2acf9f30.png";